import { createSelector } from '@reduxjs/toolkit';

import type { IntegracaoAlertaNivel } from '@/features/admin-geral/types/saudeIntegracoes';
import type { RootState } from '@/store';

export const selectSaudeSnapshot = (state: RootState) => state.saudeIntegracoes.snapshot;
export const selectSaudeWhatsapp = (state: RootState) =>
  state.saudeIntegracoes.snapshot?.whatsapp ?? null;
export const selectSaudeWhatsappNumeros = (state: RootState) =>
  state.saudeIntegracoes.snapshot?.whatsapp?.numeros ?? [];
export const selectSaudeCpf = (state: RootState) => state.saudeIntegracoes.snapshot?.cpf ?? null;
export const selectSaudeCnpj = (state: RootState) => state.saudeIntegracoes.snapshot?.cnpj ?? null;
export const selectSaudeCapturadoEm = (state: RootState) =>
  state.saudeIntegracoes.snapshot?.capturadoEm ?? null;
export const selectAlertasIntegracoes = (state: RootState) => state.saudeIntegracoes.alertas;
export const selectSaudeLoading = (state: RootState) => state.saudeIntegracoes.loading;
export const selectSaudeRefreshing = (state: RootState) => state.saudeIntegracoes.refreshing;
export const selectSaudeError = (state: RootState) => state.saudeIntegracoes.error;
export const selectSaudeConfig = (state: RootState) => state.saudeIntegracoes.config;
export const selectSaudeSavingConfig = (state: RootState) => state.saudeIntegracoes.savingConfig;

const NIVEIS_ACIONAVEIS: ReadonlyArray<IntegracaoAlertaNivel> = ['CRITICO', 'ATENCAO'];

export const selectAlertasAcionaveis = createSelector(selectAlertasIntegracoes, (alertas) =>
  alertas.filter((a) => NIVEIS_ACIONAVEIS.includes(a.nivel)),
);

export const selectAlertasBadge = createSelector(selectAlertasAcionaveis, (acionaveis) => ({
  count: acionaveis.length,
  temCritico: acionaveis.some((a) => a.nivel === 'CRITICO'),
}));
